module.exports = __webpack_public_path__ + "img/9_37.e9f4da2f.png";